import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import {
  Button, Checkbox, FormControl, FormControlLabel, RadioGroup, Grid, Hidden, Link, ListItemIcon, ListItemText, 
  Paper, Menu, MenuItem, Radio, Select, Switch, TableContainer, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Tooltip, Typography, Tabs, Tab
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import HelpOutline from '@mui/icons-material/HelpOutline';
import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

//import ProgramForAppFetch from '../vendor/ProgramForAppFetch';
import AppOemTemplateFetch from './AppOemTemplateFetch';
import AppDeleteMutation from './AppDeleteMutation';
import AppUpdateMutation from './AppUpdateMutation';
import AppDisplay from '../ui/AppDisplay';
import AppDisplayWithMaintenance from '../ui/AppDisplayWithMaintenance';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PageTitle from '../ui/PageTitle';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import PercentageTextField from '../ui/PercentageTextField';

import SubscriptionsAcrossCustomer from './SubscriptionsAcrossCustomer';
import AppSalesReport from './AppSalesReport';
import Invitations from './Invitations';

import AppBindStyles from '../../AppBindStyles';
import { disableAttributeCheck, getValueForRender } from '../../utils/InputUtils';
import { Cloud, MonetizationOn, Settings, MailOutline } from '@mui/icons-material';
import { red, green, blue } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const AppEditQuery = graphql`
query AppEditQuery($appId: UUID!, $resellerAccountId: UUID!) {
  appTByAppId(appId: $appId) {
    appId
    accountId
    appStatus
    parentAppId
    oemAppId
    appName
    appSku
    appUrl
    signupUrl,
    appLogo
    description
    appType
    atId
    appSkuPrice
    appMarkupPercentage
    appMarkupAbsolute
    jitFloatDefault
    marqetaMid
    marqetaMname
    maxCharge
    paymentOrder
    passThroughFees
    wholesaleDiscountPercentage
    showDomain
    showUsername

    appTByOemAppId {
      appId
      appUrl
      signupUrl
      accountTByAccountId {
        accountName
        vppTsByVendorId {
          totalCount
          nodes {
            vppId
          }
        }
      }
      cpAppTsByAppId {
        totalCount
        nodes {
          cpId
          cpTByCpId {
            programName
            description
            resellerProgramTsByCpId (condition:{resellerAccountId: $resellerAccountId}) {
              totalCount
              nodes {
                resellerPId
                programName
                description
              }
            }
          }
        }
      }
    }
    customerAppTsByAppId {
      totalCount
      nodes {
        customerAppId
        paymentOrder
        appMarkupPercentage
        notes
        appStatus
        wholesaleDiscountPercentage
        accountTByCustomerAccountId {
          accountId
          accountName
        }
        bindCardTByBcId {
          bcStatus
        }
      }
    }
    cpAppTsByAppId {
      totalCount
      nodes {
        cpId
        cpTByCpId {
          programName
          description
        }
      }
    }
  }
  getresellerinvitations (reselleraccountid: $resellerAccountId, oemappid: $appId) 
  { 
    totalCount
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 1200,
    marginTop: 16
  },
  paperInner: {
    padding: theme.spacing(2)
  },
  percentageTextField: {
    margin: theme.spacing(1),
    width: 104,
    minWidth: 104,
  },
  radioText: {
    marginTop: 10
  },
  rtable: {
    marginTop: 16,
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  },
  tblHeadCellLeft: {
    textAlign: 'left',
    verticalAlign: 'bottom',
    borderBottom: 0,
  },
  editicon: {
    width: 22,
    height: 22,
  },
  statusButton: {
    color: '#444'
  },
  [theme.breakpoints.up('sm')]: {
    tblCellTypeCol: {
      paddingLeft: 4,
      paddingRight: 4,
      minWidth: 20,
      width: 20,
    },
    tblCellDescCol: {
      paddingLeft: 10,
      paddingRight: 10,
      minWidth: 140,
      width: 260,
    },
    tblCellNameCol: {
      textAlign: 'left',
      minWidth: 120,
      width: 120,
    },
  },
  [theme.breakpoints.up('xs')]: {
    tblCellTypeCol: {

    },
    tblCellDescCol: {

    },
    tblCellNameCol: {
      textAlign: 'left'
    },
  },
  // tab things
  tabroot: {
    flexGrow: 1,
    margin: 0,
    width: '100%',
    //backgroundColor: theme.palette.primary.light,
    borderBottom: '2px solid #dedede'
  },
  tabScrollButton: {
    flex: '0 0 0px'
  },
  /* Hidden below is sort of a hack.  Without overflow hidden - scroll bars appear but were not revealing 
  more data.  It was not obvious what is causing it.  Needs more research */

  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    tabContainer: {
      padding: 0,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'xx-small',
    },
    labelContainer: {
      paddingLeft: 4,
      paddingRight: 4,
    },
    label: {
      fontSize: 'xx-small',
    },
    labelWrapped: {
      fontSize: 'xx-small',
    },
  }
  ,
  [theme.breakpoints.up('sm')]: {
    tabContainer: {
      padding: 8,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'x-small',
    },
    labelContainer: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    label: {
      fontSize: 'x-small',
    },
    labelWrapped: {
      fontSize: 'x-small',
    },
  },
  [theme.breakpoints.up('md')]: {
    tabContainer: {
      padding: 20,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: '0.75rem',
    },
    labelContainer: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    label: {
      fontSize: '0.75rem',
    },
    labelWrapped: {
      fontSize: '0.75rem',
    },
  }
});

class AppEdit extends Component {
  state = {
    showSpinner: false,
    saveStatus: null,
    saveMessage: null,
    saveSnackbarOpen: false,
    saveSnackbarDuration: null,
    confirmDelete: false,
    appStatus: null,
    appName: null,
    appSku: null,
    appUrl: null,
    signupUrl: null,
    appLogo: null,
    description: null,
    appType: null,
    appSkuPrice: null,
    appMarkupAbsolute: null,
    appMarkupPercentage: null,
    paymentOrder: null,
    passThroughFees: null,
    wholesaleDiscountPercentage: null,
    showDomain: null,
    showUsername: null,
    vendorOemTemplateAppCount: 1,
    tabValue: 0,
    anchorEl: null
    /*
    programName: null,
    programId: null,
    programDescription: null
    */
  }


  componentDidMount() {
    if (this.props.auth.isAuthenticatedVendor()) {

      const params = new URLSearchParams(this.props.location.search);
      let appId = params.get('appId');
      let accountId = abEnvironment.getUserAttribute("a_id");


      AppOemTemplateFetch.fetch(accountId, appId).toPromise()
        .then(aotf => {

          if (aotf.allAppTs) {

            let vendorOemTemplateAppCount = aotf.allAppTs.nodes[0].appTsByOemAppId.totalCount;
            this.setState({ vendorOemTemplateAppCount: Number.parseInt(vendorOemTemplateAppCount, 10) });

          }
        })
        .catch(err => {
          //assume there is at least one template app until proven otherwise
          this.setState({ vendorOemTemplateAppCount: 1 });
        })
    } else {
      const params = new URLSearchParams(this.props.location.search);
      let tab = params.get('tab');
      if (tab === 'settings') {
        localStorage.setItem('appEditTabVal', 2);
        this.setState({tabValue: 2});
      }
    }
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  goBack() {
    this.props.history.goBack();
  }

  getValueForNonVendorLinkRender(state_member, prop_member, theDefault) {
    if (state_member === '') {
      return theDefault;
    }
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  handleRadioChange = event => {
    let theNum = parseInt(event.target.value, 10);
    this.setState({ paymentOrder: theNum });
  }

  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
    localStorage.setItem('appEditTabVal', value);
  }

  disableAppSave(appProps) {
    if (appProps === null)
      return true;

    //SDW NOTE:  I left app and signup URL here even though they no longer appear on page in case we add back.
    let retval = disableAttributeCheck(this.state.appStatus, appProps.appStatus) &&
      disableAttributeCheck(this.state.appName, appProps.appName) &&
      disableAttributeCheck(this.state.appSku, appProps.appSku) &&
      disableAttributeCheck(this.state.appLogo, appProps.appLogo) &&
      disableAttributeCheck(this.state.appUrl, appProps.appUrl) &&
      disableAttributeCheck(this.state.signupUrl, appProps.signupUrl) &&
      disableAttributeCheck(this.state.description, appProps.description) &&
      disableAttributeCheck(this.state.appSkuPrice, appProps.appSkuPrice) &&
      disableAttributeCheck(this.state.appMarkupAbsolute, appProps.appMarkupAbsolute) &&
      disableAttributeCheck(this.state.appMarkupPercentage, appProps.appMarkupPercentage) &&
      disableAttributeCheck(this.state.paymentOrder, appProps.paymentOrder) &&
      disableAttributeCheck(this.state.wholesaleDiscountPercentage, appProps.wholesaleDiscountPercentage) &&
      disableAttributeCheck(this.state.showDomain, appProps.showDomain) &&
      disableAttributeCheck(this.state.showUsername, appProps.showUsername) &&
      disableAttributeCheck(this.state.passThroughFees, appProps.passThroughFees);

    if (!retval) {
      //one field above changed.  true means disable, false means enable
      //check for valid domains in the Url fields as well
      if (this.disableForInvalidDomainName(this.state.appUrl) ||
        this.disableForInvalidDomainName(this.state.signupUrl)) {
        retval = true;
      }
    }

    if (this.areFieldsInError()) {
      return true;
    }

    return retval;
  }

  disableForInvalidDomainName(stateVar) {

    if (stateVar !== null && stateVar !== '') {
      //something changed, validate against reg ex domain check  (used this pattern: https://regexr.com/3au3g)
      var re = new RegExp(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/);
      return !re.test(stateVar);
    } else {
      return false;
    }

  }

  showSpinner() {
    return this.state.showSpinner;
  }

  handleAppStatusChange = (event) => {
    this.setState({ 'appStatus': parseInt(event.target.value, 10) });
  };

  getValueForSelectRender(propPaymentOrder) {

    if (this.state.paymentOrder != null) {
      if (this.state.paymentOrder <= 1) {
        return 1;
      }
      else {
        return 2;
      }
    }

    if (propPaymentOrder != null) {
      if (propPaymentOrder <= 1) {
        return 1;
      } else {
        return 2;
      }
    }

    return 1;
  }


  getErrorMessage(field, minValue, maxValue) {
    let errMesg = null;

    let value = Number(field);
    if (value < minValue) {
      return 'Cannot be less than ' + minValue;
    }
    if (value > maxValue) {
      return 'Cannot be greater than ' + maxValue;
    }

    return errMesg;
  }

  areFieldsInError() {
    if (this.getErrorMessage(this.state.appMarkupPercentage, -100, 900) !== null) {
      return true;
    }
    if (this.getErrorMessage(this.state.wholesaleDiscountPercentage, 0, 100) !== null) {
      return true;
    }
    return false;
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  }
  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const okColor = green[300];
    const deleteColor = red[300];
    const suspendColor  = blue[300];

    let wholesaleTooltip = `Some software vendors sell partners discounted subscriptions. You in turn then mark the subscription up and sell it to your customers.
        \n\r
        It’s important to show only the retail price for the subscription to your customer. Any discounts should come from you, which you can add on the next line below.`

    let additionalFieldsToolip = 'All apps have email and password fields. Some have additional fields (e.g. username); if needed, you can select these here';

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedVendor()) {
      let { tabValue } = this.state;
      if (localStorage.getItem('appEditTabVal') != null) {
        tabValue = parseInt(localStorage.getItem('appEditTabVal'), 10);
      }

      const params = new URLSearchParams(this.props.location.search);
      let appId = params.get('appId');
      let fp = params.get('fp');

      let signupLabel = "Signup/referral link";
      if (isAuthenticatedVendor()) {
        signupLabel = "Signup link";
      }

      let backTo = "App Catalog";
      if (fp != null && fp !== '') {
        backTo = fp;
      }

      let myAccountId = abEnvironment.getUserAttribute("a_id");
      let commissionProgCount = 0;

      // For now, showing wholesale discount for all apps.  We anticipate
      // overriding this on an app by app basis in the future.
      let showWholesaleDiscount = true;

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={AppEditQuery}
          variables={{ appId: appId, resellerAccountId: myAccountId }}
          render={({ error, props }) => {
            if (error) {
              logError(error.message);
              return (
                <ServerError />
              );
            } else if (props) {
              if (props.appTByAppId === null) {
                return (
                  <div className={classes.root}>
                    <PageTitle title={"App not found"} showBackButton={true} name={backTo} history={this.props.history}/>
                  </div>
                );
              }

              // Only show expensing options if expensing is enabled
              let expensingActive = false;
              let expensing = abEnvironment.getFlagValue("expensing");
              if (expensing != null && expensing.flagValue === 1) {
                expensingActive = true;
              }          

              //check for invitations
              let invitationsTab = null;
              let subscriptionsTab = 0;
              let salesTab = 1;
              let settingsTab = 2;
              if (props.getresellerinvitations.totalCount > 0) {
                invitationsTab = 0;
                subscriptionsTab = 1;
                salesTab = 2;
                settingsTab = 3;

                if (expensingActive === false) {
                  salesTab = null;
                  settingsTab = 2;
                }
              } else {
                if (expensingActive === false) {
                  salesTab = null;
                  settingsTab = 1;
                }
              }

              let theAppName = getValueForRender(this.state.appName, props.appTByAppId.appName, '');
              let theAppSku = getValueForRender(this.state.appSku, props.appTByAppId.appSku, '');
              let theDescription = getValueForRender(this.state.description, props.appTByAppId.description, '');
              let thePaymentOrder = getValueForRender(this.state.paymentOrder, props.appTByAppId.paymentOrder, 4);
              if (thePaymentOrder === 1) {
                thePaymentOrder = 0;
              }
              if (expensingActive === false && (thePaymentOrder === 0 || thePaymentOrder === 2)) {
                thePaymentOrder = 4;
              }
              let expenseToCustomerTitle = 'Expense to customer';
              let expenseToCustomerDescription = 'Automatically expense this subscription to my customer after I sign up on their behalf.';
              let expenseToMeTitle = 'I will pay';
              let expenseToMeDescription = 'I will cover the cost of the subscription as part of the project.';
              let requestAccessTitle = 'Request access';
              let requestAccessDescription = 'Ask my customer to share their password or invite me into their subscription.';
              let signUpTitle = "I will sign up";
              let signUpDescription = "I will sign up for this subscription on behalf of my customer.";
      
              // This is only relevant for vendor views
              let commissionProgramLink = null;
              let programName = '';
              if (isAuthenticatedVendor() && props.appTByAppId.cpAppTsByAppId.totalCount !== 0) {
                //should only be 1....
                commissionProgramLink = 'vendorcommprogramedit?cpId=' + props.appTByAppId.cpAppTsByAppId.nodes[0].cpId + '&fp=App';
                programName = props.appTByAppId.cpAppTsByAppId.nodes[0].cpTByCpId.programName;
              }

              // This is only relevant for reseller views
              // - note that we assume that an app can only be in one vendor program, which is why we hardcode to node 0
              //   of cpAppTsByAppId.
              //   However, there could be more than one reseller program that relates to the app, as more than one reseller
              //   program can point to the same vendor program.
              let vppId = null;
              let oemApp = props.appTByAppId.appTByOemAppId;
              if (oemApp && oemApp.accountTByAccountId && oemApp.accountTByAccountId.vppTsByVendorId) {
                if (oemApp.accountTByAccountId.vppTsByVendorId.nodes[0]) {
                  let vvp = oemApp.accountTByAccountId.vppTsByVendorId.nodes[0];
                  vppId = vvp.vppId;
                }
              }

              let resellerProgramsForApp = null;
              let resellerProgramHeading = 'This app is qualified for a commission plan';
              if (props.appTByAppId.appTByOemAppId != null &&
                props.appTByAppId.appTByOemAppId.cpAppTsByAppId.totalCount > 0 &&
                props.appTByAppId.appTByOemAppId.cpAppTsByAppId.nodes[0].cpTByCpId != null) {
                let i = 0;
                let y = 0;

                for (i = 0; i < props.appTByAppId.appTByOemAppId.cpAppTsByAppId.nodes.length; i++) {
                  let programNodes = props.appTByAppId.appTByOemAppId.cpAppTsByAppId.nodes[i].cpTByCpId.resellerProgramTsByCpId.nodes;
                  for (y = 0; y < programNodes.length; y++) {
                    if (!resellerProgramsForApp) {
                      resellerProgramsForApp = [];
                    }
                    resellerProgramsForApp.push(programNodes[y]);
                  }
                }

                if (resellerProgramsForApp && resellerProgramsForApp.length > 1) {
                  resellerProgramHeading = 'This app is qualified for ' + resellerProgramsForApp.length + ' commission plans';
                }
              }

              // Put the subscribers in alpha order
              let subscribers = [];
              if (props.appTByAppId != null &&
                props.appTByAppId.customerAppTsByAppId != null &&
                props.appTByAppId.customerAppTsByAppId.nodes != null) {
                let subsNodes = props.appTByAppId.customerAppTsByAppId.nodes;
                for (let i = 0; i < subsNodes.length; i++) {
                  let n = subsNodes[i];
                  let theAccountName = n.accountTByCustomerAccountId.accountName;
                  let theAccountId = n.accountTByCustomerAccountId.accountId;
                  let theModel = 'Expense to me';
                  if (n.paymentOrder === 0 || n.paymentOrder === 1) {
                    let mkds = '';
                    if (n.appMarkupPercentage > 0) {
                      mkds = 'with a ' + parseFloat(n.appMarkupPercentage).toFixed(2) + '% markup'
                    } else if (n.appMarkupPercentage < 0) {
                      mkds = 'with a ' + parseFloat(n.appMarkupPercentage * -1).toFixed(2) + '% discount'
                    }

                    theModel = 'Expense to ' + theAccountName + ' ' + mkds;
                  }

                  let theHref = '';
                  if (myAccountId !== theAccountId) {
                    theHref = "customer?accountId=" + theAccountId + "&fp=App";
                  }
                  let subsHref = "subscription?customerAppId=" + n.customerAppId + "&fp=App";

                  let aSub = {
                    customerAppId: n.customerAppId,
                    accountName: theAccountName,
                    accountHref: theHref,
                    subscriptionHref: subsHref,
                    model: theModel,
                    notes: n.notes,
                    customerAppStatus: n.appStatus,
                    bcStatus: n.bindCardTByBcId.bcStatus,
                  };
                  subscribers.push(aSub);
                }
              }
              // Sort
              if (subscribers.length > 1) {
                subscribers.sort((a, b) => {
                  if (a.accountName > b.accountName) { return 1; }
                  if (a.accountName < b.accountName) { return -1; }
                  return 0;
                });
              }

              let showDomain = (this.state.showDomain !== null) ? this.state.showDomain : props.appTByAppId.showDomain;
              let showUsername = (this.state.showUsername !== null) ? this.state.showUsername : props.appTByAppId.showUsername;

              return (
                <Grid container spacing={3} direction="row" justifyContent="flex-start">
                  <Grid item xs={12}>
                    <PageTitle title="Manage app" showBackButton={true} name={backTo} noMargin={true} history={this.props.history}/>
                  </Grid>
                  <Grid item xs={12}>
                    {/* Non-vendor experience */}
                    {!isAuthenticatedVendor() &&
                    <React.Fragment>
                      <Paper className={classes.paper}>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                          {/* Name, logo, active setting. */}
                          <Grid item xs={12} >
                            <Grid container spacing={0} direction="row" justifyContent='space-between' alignItems='flex-start'>
                              <Grid item xs={10}>
                                <AppDisplay appLogo={props.appTByAppId.appLogo}
                                  appName={theAppName}
                                  appSku={theAppSku}
                                  description={theDescription} />
                              </Grid>

                              {(props.appTByAppId.appStatus === 0)  &&
                              <Grid item>
                                <Button color="secondary"
                                  aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                                  aria-haspopup='true'
                                  onClick={this.handleMenuClick}
                                  className={classes.statusButton}
                                >
                                  {/* <CheckCircle htmlColor={okColor} /><Hidden only={['xs', 'sm']}>&nbsp;Active&nbsp;</Hidden><Hidden only={['xs', 'md', 'lg', 'xl']}>&nbsp;Act&nbsp;</Hidden><ArrowDropDown /> */}
                                  <CheckCircle htmlColor={okColor} /><Hidden only={['xs', 'sm']}>&nbsp;Active&nbsp;</Hidden><ArrowDropDown />
                                </Button>
                                <Menu
                                  id="action-menu"
                                  anchorEl={this.state.anchorEl}
                                  open={Boolean(this.state.anchorEl)}
                                  onClose={this.handleMenuClose}>

                                  <MenuItem onClick={() => { this._suspendApp(appId); }}>
                                    <ListItemIcon>
                                      <PauseCircleFilled htmlColor={suspendColor}/>
                                    </ListItemIcon>
                                    <ListItemText primary="Suspend" />
                                  </MenuItem>
                                  {props.appTByAppId.customerAppTsByAppId.totalCount === 0 &&

                                    <MenuItem onClick={() => { this.setState({ confirmDelete: true, anchorEl: null }); }}
                                        disabled={commissionProgramLink !== null && isAuthenticatedVendor()}>
                                      <ListItemIcon>
                                        <Delete htmlColor={deleteColor} />
                                      </ListItemIcon>
                                      <ListItemText primary="Delete" />
                                    </MenuItem>
                                  }

                                </Menu>
                              </Grid>
                              }
                              {(props.appTByAppId.appStatus === 1)  &&
                              <Grid item>
                                <Button color="secondary"
                                  aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
                                  aria-haspopup='true'
                                  onClick={this.handleMenuClick}
                                  className={classes.statusButton}
                                >
                                  {/* <CheckCircle htmlColor={okColor} /><Hidden only={['xs', 'sm']}>&nbsp;Active&nbsp;</Hidden><Hidden only={['xs', 'md', 'lg', 'xl']}>&nbsp;Act&nbsp;</Hidden><ArrowDropDown /> */}
                                  <PauseCircleFilled  htmlColor={suspendColor} /><Hidden only={['xs', 'sm']}>&nbsp;Suspended&nbsp;</Hidden><ArrowDropDown />
                                </Button>
                                <Menu
                                  id="action-menu"
                                  anchorEl={this.state.anchorEl}
                                  open={Boolean(this.state.anchorEl)}
                                  onClose={this.handleMenuClose}>

                                  <MenuItem onClick={() => { this._activateApp(appId); }}>
                                    <ListItemIcon>
                                      <PlayCircleFilled htmlColor={okColor} />
                                    </ListItemIcon>
                                    <ListItemText primary="Unsuspend" />
                                  </MenuItem>

                                </Menu>
                              </Grid>
                              }

                            </Grid>
                          </Grid>
                          {/* Tabs */}
                          <Grid container spacing={0} direction="row" justifyContent="space-around">
                            <Grid item xs={12}>

                              <Tabs
                                value={tabValue}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                scrollButtons="auto"
                                classes={{ root: classes.tabroot, scrollButtons: classes.tabScrollButton }}>
                                {invitationsTab != null &&
                                <Tab label="Invitations" icon={<MailOutline />}
                                  classes={{
                                      root: classes.tab,
                                      wrapper: classes.labelWrapped,
                                    }}
                                />}
                                <Tab
                                  label="Subscriptions" icon={<Cloud />}
                                  classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                  }}
                                />
                                { salesTab != null &&
                                <Tab
                                  label="Sales" icon={<MonetizationOn />}
                                  classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                  }}
                                />}
                                <Tab
                                  label="Settings" icon={<Settings />}
                                  classes={{
                                    root: classes.tab,
                                    wrapper: classes.labelWrapped,
                                  }}
                                />
                              </Tabs>
                            </Grid>
                          </Grid>
                          {/* tab content containers */}
                          <Grid item xs={12}>
                            {tabValue === invitationsTab &&
                            <Invitations 
                                auth={this.props.auth}
                                history={this.props.history}
                                appId={appId}
                            />}
                            {tabValue === subscriptionsTab &&
                            <Grid container spacing={2} direction="row" justifyContent="space-between" >
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container>
                                    <Grid item xs={12}>
                                      <Typography variant="h6">Subscriptions</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <SubscriptionsAcrossCustomer auth={this.props.auth} history={this.props.history} appId={appId} loginLink={(props.appTByAppId.appUrl !== "") ? props.appTByAppId.appUrl : null} fromAppEdit={true}></SubscriptionsAcrossCustomer>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            </Grid>}
                            {tabValue === salesTab &&
                            <Grid container spacing={2} direction="row" justifyContent="space-between" >
                              {resellerProgramsForApp != null &&
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container>
                                    <Grid item xs={12}>
                                      <Typography variant="h6">Commission plan</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Typography variant="body2">
                                        {resellerProgramHeading}
                                      </Typography>
                                    </Grid>
                                  </Grid>

                                  <TableContainer>
                                    <Table className={classes.rtable}>
                                      <TableHead className={classes.tblHead}>
                                        <TableRow className={classes.tblHeadRow}>
                                          <TableCell className={classes.tblHeadCellLeft}>Name</TableCell>
                                          <TableCell className={classes.tblHeadCellLeft}>Description</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {resellerProgramsForApp.map(n => {
                                          commissionProgCount++;

                                          let programLink = null;
                                          if (vppId !== null) {
                                            programLink = 'vendorpartnerprogram?vppId=' + vppId;

                                          }

                                          let commissionProgramLink = 'resellercommprogramview?resellerPId=' + n.resellerPId + '&fp=App';

                                          return (
                                            <TableRow className={classes.tblHeadRow} key={commissionProgCount}>
                                              <TableCell className={classes.tblHeadCellLeft}>
                                                {programLink &&
                                                  <Link component="button"
                                                    variant="body2"
                                                    onClick={this.goTo.bind(this, programLink)}>
                                                    {n.programName}
                                                  </Link>
                                                }
                                                {!programLink && commissionProgramLink &&
                                                  <Link component="button"
                                                    variant="body2"
                                                    onClick={this.goTo.bind(this, commissionProgramLink)}>
                                                    {n.programName}
                                                  </Link>
                                                }
                                              </TableCell>
                                              <TableCell className={classes.tblHeadCellLeft}>{n.description}</TableCell>
                                            </TableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Paper>
                              </Grid>
                              }
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <Typography variant="h6">Sales report</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <AppSalesReport appId={appId} resellerAccountId={myAccountId} auth={this.props.auth} history={this.props.history} />
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            </Grid>}
                            {tabValue === settingsTab &&
                            <Grid container spacing={2} direction="row" justifyContent="space-between">
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                      <Typography variant="h6">App description</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="app-name" label="App name"
                                        value={theAppName}
                                        onChange={(e) => this.setState({ appName: e.target.value })}
                                        inputProps={{ maxLength: 64 }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="app-sku" label="Subscription plan"
                                        value={theAppSku}
                                        onChange={(e) => this.setState({ appSku: e.target.value })}
                                        inputProps={{ maxLength: 32 }}
                                      />
                                    </Grid>

                                    <Grid item xs={12}>
                                      <TextField
                                        id="description" label="Description"
                                        value={theDescription}
                                        multiline
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                        inputProps={{ maxLength: 2048 }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={2}>

                                    <Grid item xs={12}>
                                      <Typography variant="h6">Login and signup</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="login-url" label="Login link"
                                        value={this.getValueForNonVendorLinkRender(this.state.appUrl,
                                          props.appTByAppId.appUrl,
                                          ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.appUrl : ''))
                                        }
                                        onChange={(e) => this.setState({ appUrl: (e.target.value !== '' ? e.target.value : ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.appUrl : '')) })}
                                        inputProps={{ maxLength: 256 }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <TextField
                                        id="signup-url" label={signupLabel}
                                        value={this.getValueForNonVendorLinkRender(this.state.signupUrl,
                                          props.appTByAppId.signupUrl,
                                          ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.signupUrl : ''))}
                                        onChange={(e) => this.setState({ signupUrl: (e.target.value !== '' ? e.target.value : ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.signupUrl : '')) })}
                                        inputProps={{ maxLength: 256 }}
                                      />
                                    </Grid>
                                    {(props.appTByAppId.appTByOemAppId == null) &&
                                      <React.Fragment>
                                        <Grid item xs={12} />
                                        <Grid item xs={12}>
                                          <Grid container direction="column" spacing={0}>
                                            <Grid item style={AppBindStyles.markupDescription}>
                                              <Typography variant="h6" display="inline">Configure additional fields</Typography>
                                              <Tooltip placement='bottom' title={additionalFieldsToolip}>
                                                <HelpOutline fontSize="small" style={{ verticalAlign: "-16%", marginLeft: '4px' }} />
                                              </Tooltip>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                          <FormControlLabel
                                            control={
                                              <Checkbox checked={showDomain === 1}
                                                onChange={() => this.setState({ showDomain: (showDomain === 1) ? 0 : 1 })}
                                              />
                                            }
                                            label="Show domain"
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                          <FormControlLabel
                                            control={
                                              <Checkbox checked={showUsername === 1}
                                                onChange={() => this.setState({ showUsername: (showUsername === 1) ? 0 : 1 })}
                                              />
                                            }
                                            label="Show user name"
                                          />
                                        </Grid>
                                      </React.Fragment>
                                    }
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item xs={12}>
                                <Paper className={classes.paperInner}>
                                  <Grid container spacing={1} direction="row" justifyContent="space-between">
                                    <Grid item xs={12}>
                                      <Grid container spacing={0} direction="row" justifyContent="flex-start">
                                        <Grid item xs={12}>
                                          <Typography variant="h6">Sharing model default</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Typography variant="body2">Set the default sharing model for subscriptions to {theAppName}</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <TextField
                                        value={thePaymentOrder}
                                        onChange={(e) => {
                                          if (e.target.value === 2) {
                                            this.setState({ paymentOrder: e.target.value, appMarkupPercentage: 0, wholesaleDiscountPercentage: 0 });
                                          } else {
                                            this.setState({ paymentOrder: e.target.value });
                                          }
                                        }}
                                        label="Sharing model"
                                        select
                                        fullWidth
                                        autoFocus
                                        variant="standard"
                                      >
                                        <MenuItem value="NA" disabled>
                                            <Typography align="left" variant="body1">Select a sharing model</Typography>
                                        </MenuItem>
                                        <MenuItem value={4}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{requestAccessTitle}</Typography>
                                                </Grid>                  
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body2">{requestAccessDescription}</Typography>
                                                </Grid>
                                            </Grid>
                                        </MenuItem>
                                        <MenuItem value={5}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{signUpTitle}</Typography>
                                                </Grid>                  
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body2">{signUpDescription}</Typography>
                                                </Grid>
                                            </Grid>
                                        </MenuItem>
                                        {expensingActive === true &&
                                        <MenuItem value={0}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{expenseToCustomerTitle}</Typography>
                                                </Grid>                  
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body2">{expenseToCustomerDescription}</Typography>
                                                </Grid>
                                            </Grid>
                                        </MenuItem>}
                                        {expensingActive === true &&
                                        <MenuItem value={2}>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body1" style={AppBindStyles.boldLabel}>{expenseToMeTitle}</Typography>
                                                </Grid>                  
                                                <Grid item xs={12}>
                                                    <Typography align="left" variant="body2">{expenseToMeDescription}</Typography>
                                                </Grid>
                                            </Grid>
                                        </MenuItem>}
                                      </TextField>
                                    </Grid>

                                    {thePaymentOrder === 0 &&
                                    <React.Fragment>
                                      {showWholesaleDiscount &&
                                        <React.Fragment>
                                          <Grid item xs={12} />
                                          <Grid item>
                                            <Grid container direction="column" spacing={0}>
                                              <Grid item>
                                                <Typography variant="body1" style={AppBindStyles.boldLabel}>If you are buying {theAppName} with a partner discount, enter it here</Typography>
                                              </Grid>
                                              <Grid item style={AppBindStyles.markupDescription}>
                                                <Typography variant="caption">(e.g. if you’re charged $80 at a 20% discount, we’ll show the customer a retail price of $100)</Typography>
                                                <Tooltip placement='bottom' title={wholesaleTooltip}>
                                                  <HelpOutline fontSize="small" style={{ verticalAlign: "-16%", marginLeft: '4px' }} />
                                                </Tooltip>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                          <Grid item>
                                            <PercentageTextField
                                              id="wholesale-disc-percentage" className={classes.percentageTextField}
                                              value={getValueForRender(this.state.wholesaleDiscountPercentage, props.appTByAppId.wholesaleDiscountPercentage, '0')}
                                              onChange={(e) => this.setState({ wholesaleDiscountPercentage: e.target.value })}
                                              showErrMsg={true}
                                              allowNegative={false}
                                              minValue={0}
                                              maxValue={100}
                                              minEnterValue={0}
                                              maxEnterValue={9999}
                                              textAlign="right" />
                                          </Grid>
                                        </React.Fragment>
                                      }

                                      <Grid item xs={12} />
                                      <Grid item>
                                        <Grid container direction="column" spacing={0}>
                                          <Grid item>
                                            <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Add your management fee or discount"}</Typography>
                                          </Grid>
                                          <Grid item style={AppBindStyles.markupDescription}>
                                            <Typography variant="caption">Add a management fee (e.g. 20%) or a discount (e.g. -10%)</Typography>
                                            <Tooltip placement='bottom' title={'On top of the retail price, you can add your own management fee or discount.'}>
                                              <HelpOutline fontSize="small" style={{ verticalAlign: "-16%", marginLeft: '4px' }} />
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item>
                                        <PercentageTextField
                                          id="app-markup-percentage" className={classes.percentageTextField}
                                          value={getValueForRender(this.state.appMarkupPercentage, props.appTByAppId.appMarkupPercentage, '0')}
                                          onChange={(e) => this.setState({ appMarkupPercentage: e.target.value })}
                                          allowNegative={true}
                                          showErrMsg={true}
                                          minValue={-100}
                                          maxValue={900}
                                          minEnterValue={-9999}
                                          maxEnterValue={9999}
                                          textAlign="right"
                                        />
                                      </Grid>

                                      <Grid item xs={12} />
                                      <Grid item>
                                        <Grid container direction="column" spacing={0}>
                                          <Grid item>
                                            <Typography variant="body1" style={AppBindStyles.boldLabel}>Pass payment fees to my customer</Typography>
                                          </Grid>
                                          <Grid item style={AppBindStyles.markupDescription}>
                                            <Typography variant="caption">AppBind charges 1% plus any credit card fees</Typography>
                                            <Tooltip placement='bottom' title='If funding by credit card, fees are 2.9% US and 3.9% international + $0.30'>
                                              <HelpOutline fontSize="small" style={{ verticalAlign: "-16%", marginLeft: '4px' }} />
                                            </Tooltip>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid item>
                                        <Switch checked={getValueForRender(this.state.passThroughFees, props.appTByAppId.passThroughFees, '') === 1}
                                          onChange={(e, checked) => {
                                            if (checked) {
                                              this.setState({ passThroughFees: 1 });
                                            } else {
                                              this.setState({ passThroughFees: 0 });
                                            }
                                          }}
                                        />
                                      </Grid>
                                    </React.Fragment>}
                                  </Grid>
                                </Paper>
                              </Grid>
                              <Grid item >
                                <SaveButton
                                  snackbarOpen={this.state.saveSnackbarOpen}
                                  autoHideDuration={this.state.saveSnackbarDuration}
                                  status={this.state.saveStatus}
                                  message={this.state.saveMessage}
                                  disabled={this.disableAppSave(props.appTByAppId)}
                                  onSaveClick={() => { this._updateApp(appId) }}
                                  onSnackbarClose={() => { this._onSnackbarClose(); }}
                                />
                              </Grid>
                            </Grid>}
                          </Grid>
                        </Grid>

                        <ConfirmationDialog
                          open={this.state.confirmDelete}
                          onClose={() => { this.setState({ confirmDelete: false }); }}
                          onConfirm={() => { this._deleteApp(appId); }}
                          onCancel={() => { }}
                          title="Delete app?"
                          cancelBtn="Cancel"
                          okBtn="Ok"
                        >
                          If you proceed, the app will be deleted forever.
                        </ConfirmationDialog>
                     </Paper>
                    </React.Fragment>}

                    {/* Vendor experience */}
                    {isAuthenticatedVendor() &&
                    <React.Fragment>
                      <Paper className={classes.paper}>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                          <Grid item xs={12}>
                            <AppDisplayWithMaintenance appLogo={props.appTByAppId.appLogo}
                              appName={theAppName}
                              appSku={theAppSku}
                              description={theDescription}
                              auth={this.props.auth}
                              appId={appId} />
                          </Grid>
                          <Grid item xs={12} >
                            <Paper className={classes.paperInner}>
                              <Grid container spacing={2} direction="row" justifyContent="space-between" >
                                <Grid item xs={12}>
                                  <Typography variant="h6">App description</Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    id="app-name" label="App name"
                                    value={theAppName}
                                    onChange={(e) => this.setState({ appName: e.target.value })}
                                    inputProps={{ maxLength: 64 }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    id="app-sku" label="Subscription plan"
                                    value={theAppSku}
                                    onChange={(e) => this.setState({ appSku: e.target.value })}
                                    inputProps={{ maxLength: 32 }}
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField
                                    id="description" label="Description"
                                    value={theDescription}
                                    multiline
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    inputProps={{ maxLength: 2048 }}
                                  />
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>

                          <Grid item xs={12} >
                            <Paper className={classes.paperInner}>
                              <Grid container spacing={2} direction="row" justifyContent="space-between">
                                <Grid item xs={12}>
                                  <Typography variant="h6">Login and signup</Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    id="login-url" label="Login link"
                                    value={this.getValueForNonVendorLinkRender(this.state.appUrl,
                                      props.appTByAppId.appUrl,
                                      ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.appUrl : ''))}
                                    onChange={(e) => this.setState({ appUrl: (e.target.value !== '' ? e.target.value : ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.appUrl : '')) })}
                                    inputProps={{ maxLength: 256 }}
                                  />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <TextField
                                    id="signup-url" label={signupLabel}
                                    value={this.getValueForNonVendorLinkRender(this.state.signupUrl,
                                      props.appTByAppId.signupUrl,
                                      ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.signupUrl : ''))}
                                    onChange={(e) => this.setState({ signupUrl: (e.target.value !== '' ? e.target.value : ((props.appTByAppId.appTByOemAppId !== null) ? props.appTByAppId.appTByOemAppId.signupUrl : '')) })}
                                    inputProps={{ maxLength: 256 }}
                                  />
                                </Grid>

                                {(props.appTByAppId.appTByOemAppId == null) &&
                                  <React.Fragment>
                                    <Grid item xs={12} />
                                    <Grid item xs={12}>
                                      <Grid container direction="column" spacing={0}>
                                        <Grid item style={AppBindStyles.markupDescription}>
                                          <Typography variant="h6" display="inline">Configure additional fields</Typography>
                                          <Tooltip placement='bottom' title={additionalFieldsToolip}>
                                            <HelpOutline fontSize="small" style={{ verticalAlign: "-16%", marginLeft: '4px' }} />
                                          </Tooltip>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox checked={showDomain === 1}
                                            onChange={() => this.setState({ showDomain: (showDomain === 1) ? 0 : 1 })}
                                          />
                                        }
                                        label="Show domain"
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox checked={showUsername === 1}
                                            onChange={() => this.setState({ showUsername: (showUsername === 1) ? 0 : 1 })}
                                          />
                                        }
                                        label="Show user name"
                                      />
                                    </Grid>
                                  </React.Fragment>
                                }

                              </Grid>
                            </Paper>
                          </Grid>

                          <Grid item xs={12} >
                            <Paper className={classes.paperInner}>
                              <Grid container spacing={1} direction="row" justifyContent="space-between">
                                <Grid item xs={12}>
                                  <Typography variant="h6">Who can see this app?</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <RadioGroup aria-label="appStatus" name="appStatus"
                                    value={getValueForRender(this.state.appStatus, props.appTByAppId.appStatus, 0)}
                                    onChange={(e) => this.handleAppStatusChange(e)}>
                                    <FormControlLabel value={1} control={<Radio />} label="Nobody (make the app inactive)" />
                                    <FormControlLabel value={2} control={<Radio />} label="Registered partners only" />
                                    <FormControlLabel value={3} control={<Radio />} label="Referral only" />
                                    <FormControlLabel value={0} control={<Radio />} label="Everyone" />
                                  </RadioGroup>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>

                          {(programName !== '') &&
                          <Grid item xs={12} >
                            <Paper className={classes.paperInner}>
                              <Grid container spacing={1} direction="row" justifyContent="space-between">
                                <Grid item xs={12}>
                                  <Typography variant="h6">Commission plan</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography display="inline">This app is associated with commission plan <Link onClick={this.goTo.bind(this, commissionProgramLink)}>{programName}</Link></Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          </Grid>
                          }

                          <Grid item >
                            <SaveButton
                              snackbarOpen={this.state.saveSnackbarOpen}
                              autoHideDuration={this.state.saveSnackbarDuration}
                              status={this.state.saveStatus}
                              message={this.state.saveMessage}
                              disabled={this.disableAppSave(props.appTByAppId)}
                              onSaveClick={() => { this._updateApp(appId) }}
                              onSnackbarClose={() => { this._onSnackbarClose(); }}
                            />
                            {!this.showSpinner() && this.state.vendorOemTemplateAppCount === 0 &&
                              <Button variant="outlined" color="primary" disabled={commissionProgramLink !== null && isAuthenticatedVendor()}
                                style={AppBindStyles.bottomButton} onClick={() => { this.setState({ confirmDelete: true }); }}>
                                <Delete color="primary" /> Delete
                              </Button>}
                            <ConfirmationDialog
                              open={this.state.confirmDelete}
                              onClose={() => { this.setState({ confirmDelete: false }); }}
                              onConfirm={() => { this._deleteApp(appId); }}
                              onCancel={() => { }}
                              title="Delete app?"
                              cancelBtn="Cancel"
                              okBtn="Ok"
                            >
                              If you proceed, the app will be deleted forever.
                            </ConfirmationDialog>
                          </Grid>
                        </Grid>
                      </Paper>
                    </React.Fragment>}
                  </Grid>
                </Grid>
              );
            }
            return <LoadingSpinner />
          }}
        />
      )
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _onSnackbarClose() {
    this.setState({ saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  _updateApp = (appId) => {
    this.setState({ saveStatus: 'saving' });

    const { appStatus, appName, appSku, appUrl, signupUrl, appLogo,
      description, appType, appSkuPrice,
      appMarkupPercentage, appMarkupAbsolute, paymentOrder, passThroughFees, wholesaleDiscountPercentage, showDomain, showUsername } = this.state;

    AppUpdateMutation.commit(appId, appStatus, appName, appSku, appUrl, signupUrl, appLogo,
      description, appType, appSkuPrice,
      appMarkupAbsolute, appMarkupPercentage, paymentOrder, passThroughFees, wholesaleDiscountPercentage, null, showDomain, showUsername)
      .then(response => {
        this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'App saved.', saveSnackbarDuration: 3000 });
      })
      .catch(error => {
        this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Unable to save app', saveSnackbarDuration: null });
      });
  }

  _suspendApp = (appId) => {

    this.setState({ anchorEl: null });
    AppUpdateMutation.commit(appId, 1)
      .then(response => {
        window.location.reload();
      })
      .catch(error => {
        
      });
  }

  _activateApp = (appId) => {

    this.setState({ anchorEl: null });
    AppUpdateMutation.commit(appId, 0)
      .then(response => {
        window.location.reload();
      })
      .catch(error => {
        
      });
  }

  _deleteApp = (appId) => {
    this.setState({ showSpinner: true });
    AppDeleteMutation.commit(appId)
      .then(response => {
        this.setState({ showSpinner: false });
        this.goBack();
      })
      .catch(error => {
        this.setState({ showSpinner: false });
        this.goBack();
      });
  }
}

AppEdit.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(AppEdit);
